import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import {
  WithStyles,
  Typography,
  MenuItem,
  Grid,
  TextField,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { MyPATTextField } from "../../common";
import { RequestDetailStyle } from "../styles/RequestDetailStyle";
import classNames from "classnames";
import MyPATCalendar from "../../common/MyPATCalendar";
import InputViaDialog from "../common/InputViaDialog";
import {
  ContentRequest,
  RequestPriority,
  Client,
  Owners,
} from "../types/ContentRequest";
import AddRequestOwner from "./AddRequestOwner";
import {
  convertPriorityDisplayValue,
  convertRequestPriorityToDislayValue,
  prioritiesToDisplay,
} from "../helpers/createContentRequest";
import { RequestContentType } from "../types/ContentRequestCreate";
import ACLService from "../../acl/services/aclService";
import MyPATBaseSection, {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../common/MyPATBaseSection";
import CustomInfoIcon from "../../common/CustomInfoIcon";
//@ts-ignore
interface AddRequestDetailProps extends WithStyles<typeof RequestDetailStyle> {
  classes: any;
  selectedSubjects: string[];
  subjects: any[];
  transferToParent: (requestData: ContentRequest) => void;
  requestData: ContentRequest;
  owners: Client[];
  requestContentType: RequestContentType;
  isRequestForMyOrg: boolean;
  isSectionDisabled?: boolean;
}

interface AddRequestDetailStates {
  isOpenAddRequestDetailDialog: boolean;
  isDialogOwnerOpen: boolean;
  title: string;
  dropDownItem: any;
  startDate: Date | string;
  endDate: Date | string;
  selectPriority: any;
  owners: any[];
  ownerValue: string[];
  priority: string;
  isOwnersPresent: boolean;
  subjectOwnerMapping: any;
  compiler: any;
}

class AddRequestDetail extends Component<
  AddRequestDetailProps,
  AddRequestDetailStates
> {
  constructor(props: AddRequestDetailProps) {
    super(props);
    const {
      priority,
      startDate,
      endDate,
      owners,
      details,
    } = this.props.requestData.requestInfo;

    const propsOwners = [...owners];
    console.log("PROPSOWNERS", { propsOwners });
    this.state = {
      isOpenAddRequestDetailDialog: false,
      isDialogOwnerOpen: false,
      title: props.requestData.title,
      dropDownItem: {},
      selectPriority: "",
      ownerValue: propsOwners.length > 0 ? this.getOwner(propsOwners) : [],
      owners: [],
      startDate: startDate ? new Date(startDate) : startDate,
      endDate: endDate ? new Date(endDate) : endDate,
      priority: priority ? convertRequestPriorityToDislayValue(priority) : "",
      isOwnersPresent: propsOwners.length > 0 ? true : false,
      subjectOwnerMapping: {},
      compiler: {},
    };

    this.handleOwnerPopUp = this.handleOwnerPopUp.bind(this);
    this.onChange = _.debounce(this.onChange, 200);
    this.handleRequestOwner = this.handleRequestOwner.bind(this);
    this.setOwnerForMyOrg = this.setOwnerForMyOrg.bind(this);
  }
  componentDidUpdate(prevProps: AddRequestDetailProps) {
    if (
      this.props.isRequestForMyOrg &&
      this.props.selectedSubjects.length > 0 &&
      (prevProps.isRequestForMyOrg !== this.props.isRequestForMyOrg ||
        prevProps.selectedSubjects !== this.props.selectedSubjects ||
        prevProps.subjects !== this.props.subjects)
    ) {
      this.setOwnerForMyOrg();
    } else if (
      (prevProps.selectedSubjects.length > 0 &&
        prevProps.selectedSubjects !== this.props.selectedSubjects) ||
      (prevProps.isRequestForMyOrg !== this.props.isRequestForMyOrg &&
        !this.props.isRequestForMyOrg)
    ) {
      console.log("Update", { prevProps });
      this.setState({
        ownerValue: [],
        isOwnersPresent: false,
        owners: [],
        subjectOwnerMapping: {},
      });
    }
  }
  onChange = (fieldChanged: string) => {
    const { requestData, transferToParent } = this.props;
    const { priority } = this.state;
    const newRequestData = { ...requestData };
    if (fieldChanged === "title") {
      // @ts-ignore
      newRequestData[fieldChanged] = this.state[fieldChanged];
    } else if (fieldChanged === "priority") {
      if (!priority) {
        delete newRequestData.requestInfo.priority;
      } else {
        newRequestData.requestInfo.priority = convertPriorityDisplayValue(
          priority
        );
      }
    } else {
      // @ts-ignore
      newRequestData.requestInfo[fieldChanged] = this.state[fieldChanged];
    }

    transferToParent(newRequestData);
  };
  getSubjects() {
    const { subjects, selectedSubjects } = this.props;
    let tempSubjects: any[] = [];
    console.log({ subjects, selectedSubjects });
    subjects.forEach((subject) => {
      if (selectedSubjects.includes(subject._id)) {
        tempSubjects.push({ name: subject.name, id: subject._id });
      }
    });
    return tempSubjects;
  }
  setOwnerForMyOrg = () => {
    const {
      requestData,
      isRequestForMyOrg,
      transferToParent,
      requestContentType,
    } = this.props;
    if (isRequestForMyOrg) {
      const newRequestData = { ...requestData };
      const oldOwners = _.get(newRequestData.requestInfo, "owners", []);
      const userD = ACLService.getUserDetailsFromStorage();
      const authenticatedUser = _.get(userD, "authenticatedUser", {});
      if (_.isEmpty(authenticatedUser)) {
        return;
      }
      // @ts-ignore
      const { clientId, id, fullName } = { ...authenticatedUser };
      const user = [
        {
          name: fullName,
          id: id,
        },
      ];
      const { name, _id } = clientId;
      const client: Client = {
        name: name,
        users: [...user],
        id: _id,
      };
      const oldSubjectOwner = oldOwners.find(({ type }) => type === "subject");
      const oldTestCompiler = oldOwners.find(
        ({ type }) => type === "test-compiler"
      );

      const newSubjectOwner: Owners = {
        status: "draft",
        type: "subject",
        client: client,
        subjects: this.getSubjects(),
        roles: oldSubjectOwner ? oldSubjectOwner.roles : undefined,
      };
      const newTestCompilerOwner: Owners = {
        status: "draft",
        type: "test-compiler",
        client: client,
        subjects: [],
        roles: oldTestCompiler ? oldTestCompiler.roles : undefined,
      };
      const owners: Owners[] = [newSubjectOwner];
      if (requestContentType === RequestContentType.TEST) {
        owners.push(newTestCompilerOwner);
      }
      const newRequestInfo = { ...newRequestData.requestInfo };
      newRequestInfo.owners = owners;
      newRequestData.requestInfo = newRequestInfo;
      const ownerValue = this.getOwner(owners);

      this.setState({ owners, ownerValue, isOwnersPresent: true }, () => {
        transferToParent(newRequestData);
      });
    }
  };

  getOwner = (owners: Owners[]) => {
    const ownerValue: any = new Set();
    owners.forEach((owner: Owners) => {
      let name = owner.client.name;
      if (name.includes(owner.client.users[0].name)) {
        name = name.replace(`|${owner.client.users[0].name}`, "");
      }
      ownerValue.add(name);
    });
    return [...ownerValue];
  };
  handleOwnerPopUp() {
    this.setState({ isDialogOwnerOpen: !this.state.isDialogOwnerOpen });
  }
  handletitleChange = (event: any) => {
    this.setState(
      {
        title: event.target.value,
      },
      () => this.onChange("title")
    );
  };
  handleStartDate = (event: any) => {
    this.setState(
      {
        startDate: event,
      },
      () => this.onChange("startDate")
    );
  };
  handleEndDate = (event: any) => {
    this.setState(
      {
        endDate: event,
      },
      () => this.onChange("endDate")
    );
  };
  handlePriority = (event: any) => {
    this.setState(
      {
        priority: event.target.value,
      },
      () => this.onChange("priority")
    );
  };
  handleRequestOwner(owners: any, subjectOwnerMapping: any, compiler: any) {
    const copyOwners = [...owners];
    const ownerValue = this.getOwner(copyOwners);
    this.setState(
      {
        owners: copyOwners,
        ownerValue,
        isDialogOwnerOpen: false,
        subjectOwnerMapping,
        compiler,
      },
      () => {
        this.onChange("owners");
      }
    );
  }
  render() {
    const {
      classes,
      selectedSubjects,
      subjects,
      owners,
      requestContentType,
      isRequestForMyOrg,
      isSectionDisabled,
      requestData,
    } = this.props;
    const {
      title,
      dropDownItem,
      startDate,
      endDate,
      isDialogOwnerOpen,
      priority,
    } = this.state;
    const requestInfoSubjects = _.get(
      requestData,
      "requestInfo.details.subjects",
      []
    );

    return (
      <>
        {/* <Typography className={classes.secHeading}>
          Specify the content requirements in the request form below.
        </Typography> */}
        <MyPATBaseSection sectionId="requestDetails">
          <Grid className={classes.whiteCard}>
            <Typography
              className={classNames(
                classes.mainHeading,
                isSectionDisabled && classes.disabledSection
              )}
            >
              Task Details&nbsp;
              <CustomInfoIcon
                  infoDialogContentType="Task Details"
                  isInfoIcon={true}
                  isRightArrow={false}
                  isCenterArrow={true}
                  knowMoreAbout={false}
                  dialogTitle="Task Details"
                  imageURL="/assets/svg/contentRequest/requestDetail.svg"
                  dialogPara=""
                  details="Click to know more"
                  toolTipDirection="top"
                  otherDialogProps={{
                    fullWidth: true,
                    maxWidth: true,
                    
                  }}
                  htmlElement={
                    <>
                      <Grid container justify="center" className={classes.mtb30}>
                        <Typography className={[classes.font16,classes.mt15].join(' ')}>Through this section, you can add the following details of the task:

</Typography>
                        <Grid item className={classes.mt15}>
                          <Grid container justify="flex-start">
                            <Grid item xs={3}><strong>Title-</strong></Grid>
                            <Grid item xs={9}>The title set by you in this field will be visible to concerned assignees
 </Grid>
                          </Grid>
                          <Grid container justify="flex-start">
                            <Grid item xs={3}><strong>Owners-</strong></Grid>
                            <Grid item xs={9}>You can assign this task to different centres under your organization
 </Grid>
                          </Grid>
                          <Grid container justify="flex-start">
                            <Grid item xs={3}><strong>Priority-</strong></Grid>
                            <Grid item xs={9}>To set a priority of the task based on importance and urgency matrix. One out of four options needs to be selected in this field.
</Grid>
                          </Grid>
                          <Grid container justify="flex-start" className={classes.mb32}>
                            <Grid item xs={3}><strong>Timeline-</strong></Grid>
                            <Grid item xs={9}>You can specify the timeline of the task by mentioning the start and end date of the task
</Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  }
                />
            </Typography>

            <Grid
              container
              justify="flex-start"
              className={classNames(
                classes.whitecardContainer,
                isSectionDisabled && classes.disabledSection
              )}
            >
              <Grid item xs={12} className={classes.customInput}>
                <MyPATTextField
                  placeholder="Enter the title of the task"
                  name="RequestTitle"
                  value={title}
                  onChange={this.handletitleChange.bind(this)}
                  required
                  error={title.trim().length > 0 && title.trim().length < 5}
                  errorText="Please enter at least 5 characters"
                  fullWidthControl
                />
              </Grid>
            </Grid>
            <Grid container justify="flex-start" alignItems="center">
              <Grid
                container
                className={classNames(
                  classes.mb32,
                  isRequestForMyOrg && classes.disabledSection
                )}
              >
                <Grid item xs={4} className={classes.SubHeading}>
                  <img src="/assets/svg/contentRequest/owner.svg" />
                  <span>Owners:</span>
                </Grid>
                <Grid item xs={8}>
                  <Grid
                    className={[
                      isRequestForMyOrg ? classes.disableInput : "",
                      classes.placeholderFont,
                    ].join(" ")}
                  >
                    <InputViaDialog
                      placeholder="Select Client and Users"
                      value={this.state.ownerValue}
                      handleAddOrEdit={this.handleOwnerPopUp}
                      disabled={isRequestForMyOrg}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                className={classNames(
                  classes.mb32,
                  isSectionDisabled && classes.disabledSection
                )}
                alignItems="center"
              >
                <Grid item xs={4} className={classes.SubHeading}>
                  <img src="/assets/svg/contentRequest/priority.svg" />
                  <span>Set Your Priority:</span>
                </Grid>
                <Grid item xs={8} className={classes.dropDownWidth}>
                  <SectionFocusedContext.Consumer>
                    {({ setSectionFocus }: SectionFocusedContextValue) => (
                      <TextField
                        select
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                        value={priority || "none"}
                        onChange={this.handlePriority.bind(this)}
                        onFocus={() => setSectionFocus(true)}
                        onBlur={() => setSectionFocus(false)}
                        // dropdownItems={Object.values(RequestPriority)}
                        required
                      >
                        <MenuItem value={"none"} disabled>
                          <Typography
                            variant="body2"
                            align="left"
                            inline
                            className={classes.greyText}
                          >
                            Set your Priority
                          </Typography>
                        </MenuItem>
                        {_.map(prioritiesToDisplay, (obj) => (
                          <MenuItem value={obj} data-optionname={obj}>
                            {obj}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  </SectionFocusedContext.Consumer>
                </Grid>
              </Grid>
              <Grid
                container
                className={classNames(
                  classes.mb32,
                  isSectionDisabled && classes.disabledSection
                )}
                alignItems="center"
              >
                <Grid item xs={4} className={classes.SubHeading}>
                  <img src="/assets/svg/contentRequest/deadline.svg" />
                  <span>Set Task Timeline:</span>
                </Grid>
                <Grid item xs={8}>
                  <Grid container spacing={16}>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={this.handleStartDate.bind(this)}
                        date={startDate}
                        placeholder="Select Start Date"
                        minDate={new Date()}
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={this.handleEndDate.bind(this)}
                        date={endDate}
                        disabled={!startDate}
                        minDate={startDate}
                        placeholder="Select End Date"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MyPATBaseSection>
        {isDialogOwnerOpen && (
          <AddRequestOwner
            classes={classes}
            handleDialog={this.handleOwnerPopUp}
            selectedSubjects={selectedSubjects}
            subjects={subjects}
            transferToParent={this.handleRequestOwner}
            owners={owners}
            isOwnerPresent={this.state.isOwnersPresent}
            alreadyModifiedOwners={
              isRequestForMyOrg
                ? this.state.owners
                : this.props.requestData.requestInfo.owners
            }
            subjectOwnerMapping={this.state.subjectOwnerMapping}
            requestContentType={requestContentType}
            compiler={this.state.compiler}
            isRequestForMyOrg={isRequestForMyOrg}
            requestInfoSubjects={requestInfoSubjects}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    contentsubType: _.get(state, "testTemplate.contentSubType.list", {}),
    subjects: state.contentRequestReducer.contentRequestCreateReducer.subjects,
    selectedSubjects:
      state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
    owners: state.contentRequestReducer.contentRequestCreateReducer.owners,
  };
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(RequestDetailStyle)(AddRequestDetail));
